import React from 'react';
import { createPortal } from 'react-dom';
import clas from 'classnames';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { Button } from 'antd-v5';

interface RecallModalProps {
    open: boolean;
    code: string;
    loading: boolean;
    onCancel?: () => void;
    onConfirm?: () => void;
}

const RecallModal: React.FC<RecallModalProps> = ({ open, loading, code, onCancel, onConfirm }) => {
    const { t } = useLang('recall.modal');
    return open
        ? createPortal(
              <div className={clas(css['modal'])}>
                  <div className="modal-content">
                      <div className="modal-header">
                          <img
                              onClick={onCancel}
                              className="modal-header-close"
                              src="https://websiteoss.ecoflow.com/upload/image/1739414036074/cancel.png"
                              alt=""
                          />
                      </div>
                      <div className="modal-body">
                          <div className="modal-body-title">{t('title')}</div>
                          <div className="modal-body-desc">
                              {t('desc')}
                              <br />
                              SN：
                              <span className="highlight">{code}</span>
                          </div>
                      </div>
                      <div className="modal-footer">
                          <button className="modal-btn modal-btn-cancel" onClick={onCancel}>
                              {t('cancel')}
                          </button>
                          <Button className="modal-btn modal-btn-confirm" onClick={onConfirm} loading={loading}>
                              {t('confirm')}
                          </Button>
                      </div>
                  </div>
                  <div className="modal-mask"></div>
              </div>,
              document.body,
          )
        : null;
};
export default RecallModal;
